<template>
  <ul
    v-if="linksArrayParsed.length"
    class="highlighted-links-inside-article__wrapper"
  >
    <li
      v-for="(link, i) in linksArrayParsed"
      :key="`${link.url}-${i}`"
      class="highlighted-links-inside-article__item"
    >
      <a-link
        class="highlighted-links-inside-article__link ignore-html-styles"
        :to="generateArticlePathForLink(link)"
      >
        {{ link.title }}
      </a-link>
    </li>
  </ul>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { decodeAttributeQuotes } from '@/utils/helpers/encodeDecodeAttributeQuotes'
import { generateArticlePath } from '@/utils/helpers/url-generators'

export default {
  name: 'AHighlightedLinksInsideArticle',
  props: {
    linksData: propValidator([PROP_TYPES.STRING], false, '')
  },
  data() {
    return {
      linksArrayParsed: []
    }
  },
  methods: {
    setInitialData() {
      if (!this.linksData) return

      try {
        const formattedStr = decodeAttributeQuotes(this.linksData)

        this.linksArrayParsed = JSON.parse(formattedStr)
      } catch (err) {
        this.$errorHandler(err, this)
        console.error(err)
      }
    },
    generateArticlePathForLink(article) {
      const {
        slug: articleSlug,
        category: { slug, parentSlug }
      } = article

      const payloadForPath = {
        slug: articleSlug,
        categorySlug: parentSlug || slug,
        subcategorySlug: parentSlug ? slug : null
      }

      return generateArticlePath(payloadForPath)
    }
  },
  created() {
    this.setInitialData()
  }
}
</script>

<style lang="scss" scoped>
.highlighted-links-inside-article__item {
  margin: 16px 0 0;
}

.highlighted-links-inside-article__link {
  color: $c--gray-main;
  font-weight: 600;
  text-decoration-line: underline;
  text-decoration-color: $c--yellow;
  text-decoration-thickness: 4px;
  text-decoration-skip-ink: none; // avoids gaps in the highlight

  &:hover {
    color: $c--main;
  }
}
</style>
